export default __webpack_public_path__ + "static/media/cancel_vip.490df604.png";